module.exports = __webpack_public_path__ + "static/media/deploy_code.1a1ecc10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/deploy_code.svg
// module id = 164
// module chunks = 0